import React from 'react';

const Chip = ({ label, icon, onDelete, className = '', title, isDisplayMode, disableButton = false }) => {
  return (
    <span
      className={`inline-flex items-center border px-3 py-1 rounded-full text-sm text-gray-800 bg-white ${className} ${isDisplayMode===true?'border-[#C4C2F4]':''} ${disableButton ? 'cursor-not-allowed opacity-50' : ''}`}
    >
      {icon && <span className={isDisplayMode===true?'mr-2 text-[#C4C2F4]':'mr-2'} title={title}>{icon}</span>}
      <span title={title} className={isDisplayMode===true?'text-[#303C54]':''}>{label}</span>
      {onDelete && (
        <button type="button"
          onClick={onDelete}
          className={`ml-2 text-[#303C54] ${disableButton ? 'cursor-not-allowed opacity-50' : ''}`}          
          disabled={disableButton}
        >
          <svg className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
            <path
              fillRule="evenodd"
              d="M10 8.586l4.95-4.95 1.414 1.414L11.414 10l4.95 4.95-1.414 1.414L10 11.414l-4.95 4.95-1.414-1.414L8.586 10 3.636 5.05l1.414-1.414L10 8.586z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      )}
    </span>
  );
};

export default Chip;
